<template>
  <div class="home col-10 col-md-5 mx-auto py-5 mt-5">
		<div class="vsm--header" style="min-height:120px;margin-bottom:50px;"></div>
    <h1 v-if="dev">DEV</h1>
    <div class="card">
      <div class="card-body text-center">
        <form @submit.prevent="login" v-if="form.device_id != 0">
						<div class="form-group text-center">
							<label for="lszsz">Azonosító</label>
							<input type="number" v-model="form.lszsz" class="form-control form-control-lg text-center fs-lg" id="lszsz" required max="999">
						</div>
            <button type="submit" class="btn btn-primary btn-block my-2 btn-lg">
              Belépek
            </button>
						<a class="font-bold mt-2" @click="openGuideModal()">Zebra config guide <i class="fa fa-question-circle"></i></a>
						<h4>eszköz azonosító: {{ form.device_id }}</h4>
        </form>
				<form @submit.prevent="setDeviceId" v-else>
					<div class="alert alert-danger text-center">
						<i class="fa fa-exclamation-triangle"></i> Nincs beállítva eszköz azonosító!
						<br>
						<a class="font-bold" @click="openGuideModal()">Ne felejtsd el beállítani a zebrát! <i class="fa fa-question-circle"></i></a>
					</div>
					<div class="form-group text-center">
						<label for="device_id_to_set">Eszköz azonosító:</label>
						<input type="text" v-model="device_id_to_set" class="form-control form-control-lg text-center" id="device_id_to_set" required>
					</div>
					<span class="label label-danger" v-if="errors.device_id_to_set">
						{{ errors.device_id_to_set[0] }}
					</span>
					<button type="submit" class="btn btn-primary btn-block mt-2">
						Beállítom
					</button>
				</form>
      </div>
    </div>
		<div id="modal">
			<modal-vue modalSize="sm" @on-close="closeGuideModal()" name="guide_modal" :headerOptions="{ title: 'TC26 config guide' }" :footerOptions="{
				btn1: 'ok',
				disableBtn2: true,
				btn1OnClick: () => {
					closeGuideModal();
				},
			}">
				<div class="row d-flex justify-content-center bg-dark" > <!--v-else-->
					<div class="col-10 text-center overflow-auto">
						<div id="carouselExampleIndicators" class="carousel slide" data-interval="false">
							<ol class="carousel-indicators" style="z-index:800">
								<li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
								<li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
								<li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
								<li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
								<li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
								<li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
							</ol>
							<div class="carousel-inner">
								<div class="carousel-item active">
									<img class="d-block mx-auto" :src="require('@/assets/img/Screenshot_optios_main.png')" style="height:370px; width:auto;">
									<div class="carousel-caption d-block bg-muted text-dark p-1 mt-4" style="opacity: 0.8;">
										<h5>DataWedge alkalmazásban válasszuk ki a Profile0 (default) -ot</h5>
									</div>
								</div>
								<div class="carousel-item">
									<img class="d-block mx-auto" :src="require('@/assets/img/Screenshot_menu_basic_data.png')" style="height:370px; width:auto;">
									<div class="carousel-caption d-block bg-muted text-dark p-1 mt-4" style="opacity: 0.8;">
										<h5>Válasszuk a Basic data formatting-ot</h5>
									</div>
								</div>
								<div class="carousel-item">
									<img class="d-block mx-auto" :src="require('@/assets/img/Screenshot_data_format.png')" style="height:370px; width:auto;">
									<div class="carousel-caption d-block bg-muted text-dark p-1 mt-4" style="opacity: 0.8;">
										<h5>Állítsuk be az alábbiak szerint</h5>
									</div>
								</div>
								<div class="carousel-item">
									<img class="d-block mx-auto" :src="require('@/assets/img/Screenshot_configure_settings.png')" style="height:370px; width:auto;">
									<div class="carousel-caption d-block bg-muted text-dark p-1 mt-4" style="opacity: 0.8;">
										<h5>Menjünk a Configure scanner settingsbe</h5>
									</div>
								</div>
								<div class="carousel-item">
									<img class="d-block mx-auto" :src="require('@/assets/img/Screenshot_config.png')" style="height:370px; width:auto;">
									<div class="carousel-caption d-block bg-muted text-dark p-1 mt-4" style="opacity: 0.8;">
										<h5>Majd válasszuk a Decoders menüpontot</h5>
									</div>
								</div>
								<div class="carousel-item">
									<img class="d-block mx-auto" :src="require('@/assets/img/Screenshot_EAN13.png')" style="height:370px; width:auto;">
									<div class="carousel-caption d-block bg-muted text-dark p-1 mt-4" style="opacity: 0.8;">
										<h5>Majd pipáljuk be csak az általunk használt vonalkód típusokat</h5>
									</div>
								</div>
							</div>
							<a class="carousel-control-prev " href="#carouselExampleIndicators" role="button" data-slide="prev">
								<span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
								<span class="sr-only">Previous</span>
							</a>
							<a class="carousel-control-next " href="#carouselExampleIndicators" role="button" data-slide="next">
								<span class="carousel-control-next-icon text-dark" aria-hidden="true"></span>
								<span class="sr-only">Next</span>
							</a>
						</div>
					</div>
				</div>
			</modal-vue>
		</div>
  </div>
</template>

<script>
import User from "../../apis/User";
import appService from '../../apis/appService.js'
export default {
	data() {
		return {
			form: {
				lszsz: "",
				device_id: ""
			},
			device_id_to_set: "",
			errors: []
		};
	},
	mounted(){
		
		this.form.device_id = appService.getDeviceId();	
		
		console.log('device id:' + this.form.device_id);
		if(this.form.device_id != "0"){
			this.$store.commit('updateDeviceId',this.form.device_id);
		}
	},
	computed: {
		dev(){
			return window.location.href.indexOf("dev") > -1;
		}
	},
  methods: {
		closeGuideModal(){
			this.$vm2.close('guide_modal');
		},
		openGuideModal(){
			this.$vm2.open('guide_modal');
		},
    login() {
      User.login(this.form)
        .then(response => {
					console.log('barcode list url after login: '+response.data.barcode_list_url);
					this.$store.commit('updateBarcodeListUrl',response.data.barcode_list_url);
					
					this.$store.commit('updateLszsz',this.form.lszsz);
					this.$store.commit('updateUser',response.data);
					
				
					if(response.data.local_right_id != null){
						this.$store.commit('updateLocalRightId',response.data.local_right_id);
					}else{
						this.$store.commit('updateLocalRightId',1);
					}
					this.$store.commit('updateCountType',response.data.count_type);
					this.$root.$emit("login", true);
					localStorage.setItem("auth", "true");
        }).then(() => {
					this.$router.push({ name: "Dashboard" });
				})
        .catch(error => {
          console.log('error catchben :'+error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
		setDeviceId(){
			appService.setDeviceId(this.device_id_to_set)
			this.form.device_id = this.device_id_to_set;
			this.$store.commit('updateDeviceId',this.device_id_to_set);
			/*if(this.device_id_to_set == null){
				this.errors.device_id_to_set[0] = "adjon meg eszköz azonosítót!"
			}else{
				delete this.errors.device_id_to_set
			}*/
		}
  }
};
</script>

